// 2026-09-17：仅观察表格容器及父级，合并尺寸刷新并在卸载时清理，避免侧栏和筛选区变化造成旧布局。
import { ref, watch, onMounted, onBeforeUnmount, onUpdated, onActivated } from 'vue'

export function useTableContainer(enabled:()=>boolean=()=>true) {
  const container=ref<HTMLElement|null>(null),width=ref(0),availableHeight=ref<number|null>(null)
  let observer:ResizeObserver|undefined,frame=0,stopped=false,mounted=false
  const measure=()=>{
    frame=0
    const element=container.value
    if(stopped || !enabled() || !element || !element.getClientRects().length)return
    const nextWidth=Math.floor(element.clientWidth)
    if(nextWidth>0 && nextWidth!==width.value)width.value=nextWidth
    // 2026-09-17：旧CModal未传送到body，也须保留弹层自身高度，不能误当主列表按视口拉长。
    const topLevel=element.closest('#appmain') && !element.parentElement?.closest('table,.ant-modal,.ant-drawer,.c-modal-cover')
    const nextHeight=topLevel ? Math.max(120,Math.floor(window.innerHeight-element.getBoundingClientRect().top-40)) : null
    if(nextHeight!==availableHeight.value)availableHeight.value=nextHeight
  }
  // 2026-09-17：仅显式启用的四类清单观察尺寸；其他页面保留正式布局，不安装自动高度监听。
  const schedule=()=>{if(!stopped && enabled() && !frame)frame=window.requestAnimationFrame(measure)}
  const disconnect=()=>{if(frame)window.cancelAnimationFrame(frame);frame=0;observer?.disconnect();observer=undefined;window.removeEventListener('resize',schedule)}
  const configure=()=>{
    if(!mounted)return
    disconnect()
    if(!enabled()){width.value=0;availableHeight.value=null;return}
    measure()
    if(typeof ResizeObserver!=='undefined') {
      observer=new ResizeObserver(schedule)
      if(container.value){observer.observe(container.value);if(container.value.parentElement)observer.observe(container.value.parentElement)}
    }
    window.addEventListener('resize',schedule)
  }
  onMounted(()=>{stopped=false;mounted=true;configure()})
  watch(enabled,configure)
  onUpdated(schedule);onActivated(schedule)
  onBeforeUnmount(()=>{stopped=true;mounted=false;disconnect()})
  return {container,width,availableHeight}
}
